// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function user_list_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var profile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "profile"), null));
  if (profile.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var primary_mobile_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "primary_mobile_number"), null));
      if (primary_mobile_number.TAG === /* Ok */0) {
        var secondary_mobile_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary_mobile_number"), null));
        if (secondary_mobile_number.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    profile: profile._0,
                    name: name._0,
                    primary_mobile_number: primary_mobile_number._0,
                    secondary_mobile_number: secondary_mobile_number._0
                  }
                };
        }
        var e = secondary_mobile_number._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".secondary_mobile_number" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = primary_mobile_number._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".primary_mobile_number" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = profile._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".profile" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var customer_partner_details = Decco.listFromJson(user_list_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "customer_partner_details"), null));
  if (customer_partner_details.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              customer_partner_details: customer_partner_details._0
            }
          };
  }
  var e = customer_partner_details._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer_partner_details" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  user_list_decode ,
  t_decode ,
  
}
/* No side effect */
